export default "__VITE_ASSET__0Z7RUmLo__"